module.exports = __webpack_public_path__ + "font_darts.b9a1de65.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/font_darts.png
// module id = lbbI
// module chunks = 0